import { Notification } from 'lib/types/global';

import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from './actionTypes';
import { NotificationsAction } from './actions';

export type ScheduledNotification = Notification & { id: number };

export interface NotificationsState {
  notifications: ScheduledNotification[];
}

export const initialState: NotificationsState = {
  notifications: [],
};

let counter = 0;

export default function notificationsReducer(
  state: NotificationsState = initialState,
  action: NotificationsAction,
): NotificationsState {
  switch (action.type) {
    case ADD_NOTIFICATION: {
      const { notifications } = state;
      const { notification } = action;
      const decoratedNotification = { ...notification, id: ++counter };

      return {
        ...state,
        notifications: [...notifications, decoratedNotification],
      };
    }

    case REMOVE_NOTIFICATION: {
      const { notifications } = state;
      const { id } = action;

      return {
        ...state,
        notifications: notifications.filter((notif) => notif.id !== id),
      };
    }

    default:
      return state;
  }
}
